// css
import '../css-scss/promo-lp.scss';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';
import './windowExports';
import './web';
import './configurePartialUpdate';

// sources
import './configureLandingPage';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index-promo-lp.js